import React from 'react';
import classNames from 'classnames';
import { Select } from '@kmx/legos-react-select';
import { Form, InputGroup, TextField, Text, Modal } from '../../components';
import { Button } from '@kmx/legos-react-button';
import * as Validation from '../utils/validation';
import { suffixOptions } from '../utils/fieldValues';
import { formatPhoneNumber, formatMonthDayYear, formatEmail } from '../utils/format';
import AppForm from '../constants/app-forms';

class PersonalDataForm extends React.Component {
  constructor(props) {
    super(props);
    this.formType = AppForm.PersonalData;
    this.showSsn4 = props.requestSSN;
    this.state = {
      stateError: false,
      formFields: {
        firstName: '',
        middleName: '',
        lastName: '',
        suffix: '',
        birthday: '',
        phone: '',
        email: '',
        altemail: '',
        ssn4: '',
      },
      invalidFields: [],
    };

    this.nextJawn = this.props.handleNextStep;
    this.timer = null;
    this.initialFormRef = React.createRef();
    this.onValidateHandler = this.onValidateHandler.bind(this);
    this.updateFormFields = this.updateFormFields.bind(this);
    this.updateSuffixField = this.updateSuffixField.bind(this);
    this.scrollTop = this.scrollTop.bind(this);
    this.nextForm = this.nextForm.bind(this);
  }

  
 
  scrollTop() {
    window && window.scrollTo(0, 0);
  }

  onValidateHandler(invalidFields) {
    this.setState({ invalidFields });
  }

  updateFormFields(Validation, e) {
    this.setState({
      formFields: {
        ...this.state.formFields,
        [e.target.name]: Validation,
      },
    });
  }

  updateSuffixField(e) {
    this.setState({
      formFields: {
        ...this.state.formFields,
        suffix: e.target.value,
      },
    });
  }

  nextForm() {
    this.scrollTop();
    this.props.showAddressForm(this.state.formFields);
  }

  render() {
    const { invalidFields, modalOpen } = this.state;
    const { formFields } = this.state;
    const { firstName, middleName, lastName, suffix, birthday, phone, email, ssn4, altemail } = formFields;
    const submitDisabled = invalidFields.length > 0;

    return (
      <div className='initial-form'>
        <Form onValidate={this.onValidateHandler} ref={this.initialFormRef}>
          <div>
            {this.props.isThirdParty ? <>
              <Text.Display3>Tell us about the person for whom you're submitting this request.</Text.Display3>
              <Text.Body1 className='m-b-l'>
              In order for us to process this request, you will be required to upload documentation demonstrating
              authority to make this request on behalf of the person whose information you enter below.
              The document must be in PDF format.
            </Text.Body1>
              </> : null}
            {!this.props.isThirdParty && (
              <>
             <Text.Display3>Let&apos;s make sure we can identify you correctly</Text.Display3>
            <Text.Body1 className='m-b-l'>
              For your security, fill out the following information so that we can verify we have the right person.
              All communication from CarMax about your data privacy rights requests will only be sent to the email address provided.
            </Text.Body1>
            </>
            )}
            <InputGroup>
              <TextField
                onChange={this.updateFormFields}
                className='m-t-0 m-b-0'
                errorText='Enter a valid first name'
                label='First Name'
                name='firstName'
                required
                value={firstName}
              />
              <TextField
                onChange={this.updateFormFields}
                className='m-t-0 m-b-0' 
                errorText='Enter a valid middle name'
                label='Middle Name (optional)'
                name='middleName'
                value={middleName}
              />
            </InputGroup>

            <InputGroup>
              <TextField
                style={{ paddingBottom: '5px !important' }}
                onChange={this.updateFormFields}
                className='m-t-0 m-b-0 last-name fs-mask'
                errorText='Enter a valid last name'
                label='Last Name'
                name='lastName'
                required
                value={lastName}
              />
              <div className='suffix-dropdown'>
                <Select
                  className={classNames(['state-selection'])}
                  label='Suffix (optional)'
                  value={suffix}
                  options={suffixOptions}
                  onChange={this.updateSuffixField}
                />
              </div>
            </InputGroup>

            <InputGroup className="digits-row fs-mask">
              <TextField
                onChange={this.updateFormFields}
                icon='event'
                errorText='Enter a valid birthday (MM/DD/YYYY)'
                format={formatMonthDayYear}
                label='Birthday'
                name='birthday'
                required
                template='MM/DD/YYYY'
                value={birthday}
                validation={Validation.isValidBirthday}
              />
              {
                this.showSsn4 ? <TextField
                onChange={this.updateFormFields}
                errorText='Enter valid digits'
                label='Last 4 of SSN'
                name='ssn4'
                required
                value={ssn4}
                validation={Validation.isValidSSN4}
                inputMode="numeric"
                maxLength={4}
              /> : null
              }
              <TextField
                onChange={this.updateFormFields}
                errorText='Enter a valid phone number'
                label='Phone'
                template='XXX-XXX-XXXX'
                format={formatPhoneNumber}
                maxLength={12}
                name='phone'
                required
                value={phone}
                validation={Validation.isValidPhone}
              />
            </InputGroup>

            <InputGroup>
              <TextField
                onChange={this.updateFormFields}
                className='m-t-0 m-b-0 fs-mask'
                errorText='Enter a valid email address'
                label='Email'
                name='email'
                required
                format={formatEmail}
                validation={Validation.isValidEmail}
                value={email}
              />
            </InputGroup>
            
            <InputGroup>
              <TextField
                onChange={this.updateFormFields}
                className='m-t-0 m-b-0 fs-mask'
                errorText='Enter a valid email address or leave blank'
                label='Alternate Email (optional)'
                name='altemail'
                format={formatEmail}
                validation={Validation.isValidEmail}
                value={altemail}
              />
            </InputGroup>

  
            <Button
              className='kmx-button--full m-t-l'
              disabled={submitDisabled}
              full={true}
              level='primary'
              type='button'
              onClick={() => this.props.handleNextStep(this.formType, this.state.formFields)}>
              Continue
            </Button>
          </div>
        </Form>
        <Modal
          acceptText='Continue'
          cancelText='Cancel'
          onClose={this.onModalClose}
          open={modalOpen}
          scrollable={false}
          title='Are you sure you want to delete your information?'>
          <Text.Body1>Once we delete your information, it cannot be undone.</Text.Body1>
        </Modal>
      </div>
    );
  }
}

export default PersonalDataForm;
